export const TEXT_LIKE_FIELD_TYPES = ['text', 'email', 'tel', 'url', 'password'] as const

export const CANVAS_BASIC_INPUT_TYPES = [...TEXT_LIKE_FIELD_TYPES, 'number', 'textarea'] as const

export const SIMPLE_INPUT_FIELD_TYPES = [
  ...TEXT_LIKE_FIELD_TYPES,
  'number',
  'textarea',
  'datetime',
  'date',
  'time'
] as const

export const CONDITIONAL_FIELD_TYPES = [
  ...TEXT_LIKE_FIELD_TYPES,
  'number',
  'heading',
  'subheading',
  'formLogo',
  'select',
  'switch',
  'radio',
  'checkbox',
  'file',
  'datetime',
  'date',
  'time',
  'daterange',
  'banner',
  'captcha',
  'ratings',
  'divider',
  'textarea',
  'signature',
  'button',
  'table'
] as const

export const TIMED_FIELD_TYPES = [
  ...TEXT_LIKE_FIELD_TYPES,
  'number',
  'select',
  'checkbox',
  'textarea',
  'radio'
] as const

export type TextLikeFieldType = (typeof TEXT_LIKE_FIELD_TYPES)[number]

export const isTextLikeFieldType = (type?: string): type is TextLikeFieldType =>
  !!type && (TEXT_LIKE_FIELD_TYPES as readonly string[]).includes(type)

/** Plain input and Address both use type "text". */
export const isPlainInputFieldType = (type?: string): boolean => type === 'text'

const ADDRESS_FIELD_LABEL = /^address$/i

export const isAddressTextField = (element: { type?: string; label?: string }): boolean =>
  element?.type === 'text' && ADDRESS_FIELD_LABEL.test(String(element?.label || '').trim())

/** Plain text inputs eligible for email greeting name (excludes Address). */
export const isRecipientNamePlainInput = (element: {
  type?: string
  label?: string
  plainInput?: boolean
  addressInput?: boolean
}): boolean => {
  if (element?.type !== 'text') return false
  if (element?.addressInput === true) return false
  if (element?.plainInput === true) return true
  const label = String(element?.label || '')
    .trim()
    .toLowerCase()
  return label !== 'address'
}

/** Toggle is shown only on Plain input fields (not Address). */
export const supportsRecipientNameToggle = isRecipientNamePlainInput
